import React from 'react'

const FilterSection = () => {
  return (
    <div>FilterSection</div>
  )
}

export default FilterSection